import { api } from "./apiSetting";

/** Читаемое имя устройства по User-Agent для списка сессий. */
function getDeviceName() {
    const ua = navigator.userAgent.toLowerCase()
    let browser = 'Browser'
    if (ua.includes('edg/')) browser = 'Edge'
    else if (ua.includes('chrome')) browser = 'Chrome'
    else if (ua.includes('firefox')) browser = 'Firefox'
    else if (ua.includes('safari')) browser = 'Safari'

    let os = 'Unknown'
    if (ua.includes('android')) os = 'Android'
    else if (/iphone|ipad|ios/.test(ua)) os = 'iOS'
    else if (/macintosh|mac os/.test(ua)) os = 'macOS'
    else if (ua.includes('windows')) os = 'Windows'
    else if (ua.includes('linux')) os = 'Linux'

    return `${browser} on ${os}`
}

async function login(username, password) {
    const response = await api.post('/j/login/', {
        username,
        password,
        deviceName: getDeviceName(),
    }, {headers: {'Content-Type': 'multipart/form-data'}})
    return response
}

/** OAuth-логин для мобилки: возвращает authorization code для deep link. */
async function loginOAuth(username, password, oauthParams) {
    const response = await api.post('/oauth/authorize/', {
        username,
        password,
        ...oauthParams,
        deviceName: getDeviceName(),
    })
    return response
}

async function getOffice() {
    const response = await api('/is_office/')
    return response
}

async function loginIntern() {
    const response = await api.post('/is_office/')
    return response
}

export { login, loginOAuth, getOffice, loginIntern }
